module.exports = __webpack_public_path__ + "media/images/bg-content-51d1edf0a6fe3e480d9e5d80c679ec7e.svg";